import {createAction, props} from '@ngrx/store';
import {Update} from '@ngrx/entity';

import {Wards} from './wards.model';

export const loadWardss = createAction(
  '[Wards/API] Load Wardss',
  props<{ wardss: Wards[] }>()
);

export const addWards = createAction(
  '[Wards/API] Add Wards',
  props<{ wards: Wards }>()
);

export const upsertWards = createAction(
  '[Wards/API] Upsert Wards',
  props<{ wards: Wards }>()
);

export const addWardss = createAction(
  '[Wards/API] Add Wardss',
  props<{ wardss: Wards[] }>()
);

export const upsertWardss = createAction(
  '[Wards/API] Upsert Wardss',
  props<{ wardss: Wards[] }>()
);

export const updateWards = createAction(
  '[Wards/API] Update Wards',
  props<{ wards: Update<Wards> }>()
);

export const updateWardss = createAction(
  '[Wards/API] Update Wardss',
  props<{ wardss: Update<Wards>[] }>()
);

export const deleteWards = createAction(
  '[Wards/API] Delete Wards',
  props<{ id: string }>()
);

export const deleteWardss = createAction(
  '[Wards/API] Delete Wardss',
  props<{ ids: string[] }>()
);

export const clearWardss = createAction(
  '[Wards/API] Clear Wardss'
);


// Custom Actions
export const getAllWards = createAction(
  '[Wards/API] Get All Wards',
  props<{districUniqueId: string}>()
);
